// ActivityTypeForm.js
import React, { useEffect, useState } from "react";
import { ErrorMessage, Form, useFormikContext } from "formik";
import CustomSelect from "../../components/inputs/select";
import CustomMultiSelect from "../../components/inputs/multiSelect";
import How from "../../components/how";
import { formatUpdateDate } from "../../utils/utils";
import {
  getMyEtablissement,
  updatedEtablissement,
} from "../../store/slices/etablissementSlice";
import { useDispatch } from "react-redux";
import { toast } from "react-toastify";
import TooltipTwyny from "../tooltip";

export const ActivityTypeForm = ({
  from,
  categories,
  selectedEtablissement,
  errors,
  touched,
}) => {
  const dispatch = useDispatch();
  const { values, setFieldValue, submitForm } = useFormikContext();
  // console.log('errors',values)

  const [filteredTypes, setFilteredTypes] = useState([]);
  const [filteredActivities, setFilteredActivities] = useState([]);
  const [isExpanded, setIsExpanded] = useState(
    from === "account" ? false : true
  );
  // Initialiser isCompleted en fonction des valeurs initiales
  const [isCompleted, setIsCompleted] = useState(
      values.domaine !== "" &&
      values?.activity !== "" &&
      values?.type !== "" &&
      values?.lieux?.length !== 0 
  );
  //console.log("values",values)
  //console.log("selectedEtablissement",selectedEtablissement)
  const handleSubmit = async () => {
    // console.log('here',values)
    try {
      const data = {
        activite: values?.activity,
        domaine_activite: values?.domaine,
        type: values?.type,
        lieu_intervention: values?.lieux,
        immediat: values.immediat,
        // siret: values.siret,
        // adresse_postale: values.companyAddress,
        // code_postal: values.postalCode,
        // ville: values.city,
        // iban: values.iban,
        // identity_document_front:  values.identity_document_front
      };

      if (selectedEtablissement) {
        await dispatch(
          updatedEtablissement({
            etablissementData: data,
            route: `etablissements/${selectedEtablissement?.id}/first-update`,
          })
        ).unwrap();
        toast.success(
          "Informations de l'établissement mises à jour avec succès"
        );
        dispatch(getMyEtablissement());
      }
    } catch (error) {
      // console.log("Update failed:", error);
      toast.error(
        error?.data?.error ||
          error?.data?.message ||
          "Erreur lors de la mise à jour des informations"
      );
    }
  };
  // Lorsque les valeurs changent, mettre à jour isCompleted
  useEffect(() => {
    setIsCompleted(
      values.domaine !== "" &&
        values?.activity !== "" &&
        values?.type !== "" &&
        values?.lieux?.length !== 0
    );
  }, [values.domaine, values.activity, values.type, values.lieux]);

  // console.log({values})
  // When domaine changes, update types
  useEffect(() => {
    if (values.domaine) {
      const selectedDomaine = categories.find(
        (cat) => cat.id === values.domaine
      );

      if (selectedDomaine && selectedDomaine.children) {
        setFilteredTypes(selectedDomaine.children);
        setFilteredActivities([]);

        // Only reset if there is no value
        if (!values.type) {
          setFieldValue("type", "");
        }

        if (!values.activity && !values.type) {
          setFieldValue("activity", "");
        }
      }
    } else {
      setFilteredTypes([]);
      setFilteredActivities([]);
    }
  }, [values.domaine, values.type, categories, setFieldValue]);

  // When type changes, update activities
  useEffect(() => {
    if (values.type) {
      const selectedType = filteredTypes.find(
        (type) => type.id === values.type
      );
      if (selectedType && selectedType.children) {
        // console.log('useEffect2')
        setFilteredActivities(selectedType.children);

        if (!values.activity) {
          setFieldValue("activity", "");
        }
      }
    } else {
      setFilteredActivities([]);
    }
  }, [values.type, filteredTypes, setFieldValue]);

  const removeHowOption = (optionToRemove) => {
    const updatedLieux = values.lieux.filter(
      (option) => option !== optionToRemove
    );
    // console.log({updatedLieux})
    setFieldValue("lieux", updatedLieux);

    // Also clear any how data associated with the removed option
    // if (values.lieux) {
    //   const updatedHow = { ...values.lieux };
    //   delete updatedHow[optionToRemove];
    //   setFieldValue("lieux", updatedHow);
    // }
  };
  return (
    <div className="">
      <div className="">
        <div className="d-flex flex-wrap justify-content-between align-items-center">
          {from === "account" ? (
            <h4 className="grey500">
              Type d'activité
              <button
                type="button"
                className="btn btn-link p-0"
                onClick={() => setIsExpanded(!isExpanded)}
              >
                <img
                  src={
                    isExpanded
                      ? "/images/chevron-down.svg"
                      : "/images/chevron-down.svg"
                  }
                  className={`w-6 h-6 ${!isExpanded ? "rotate180" : ""}`}
                  alt={isExpanded ? "Réduire" : "Ouvrir"}
                />
              </button>
              {!isCompleted && selectedEtablissement ? (
                <img
                  src="/images/notCompleted.svg"
                  alt="not completed icon"
                  className="ml-8"
                />
              ) : (
                ""
              )}
            </h4>
          ) : (
            <h3 className="grey500">Type d'activité</h3>
          )}
          {from === "account" && (
            <div className="d-flex align-items-center">
              {selectedEtablissement?.updated_at && (
                <span className="body grey66 mr-16">
                  Dernière mise à jour:{" "}
                  {formatUpdateDate(selectedEtablissement.updated_at)}
                </span>
              )}
            </div>
          )}
        </div>
        {isExpanded && (
          <>
            <p className="body grey66 mt-16">
              Indiquez le type d'activité qu'offre votre établissement ainsi que
              les différents lieux où vous pouvez intervenir.
            </p>
            <Form>
              <div className="badge-pre p-16 mt-24">
                <p className="body bold500 grey500 mb-0">
                  Indiquez parmi la liste votre domaine, puis le type et votre
                  activité précise{" "}
                </p>

                {/* Domaine d'activité */}
                <div className="col-md-12 mt-8">
                  <div className="input-wrapper">
                    <label>Domaine d'activité*</label>
                    <CustomSelect
                      options={categories.map((cat) => ({
                        value: cat.id,
                        label: cat.name,
                      }))}
                      placeholder="Sélectionnez un domaine"
                      onChange={(option) => setFieldValue("domaine", option)}
                      selectedValue={values?.domaine}
                      icon={false}
                    />
                    <ErrorMessage name="domaine">
                      {(msg) => (
                        <div className="error-message mt-1">
                          <img
                            src="/images/alert-circle.svg"
                            className="arrow mr-8"
                            alt="Error"
                          />
                          {msg}
                        </div>
                      )}
                    </ErrorMessage>
                  </div>
                </div>

                {/* Type */}
                <div className="col-md-12 mt-16">
                  <div className="input-wrapper">
                    <label>Type*</label>
                    <CustomSelect
                      options={filteredTypes.map((type) => ({
                        value: type.id,
                        label: type.name,
                      }))}
                      placeholder="Choisir un type"
                      onChange={(option) => setFieldValue("type", option)}
                      selectedValue={values?.type}
                      isDisabled={!values?.domaine}
                    />
                    <ErrorMessage name="type">
                      {(msg) => (
                        <div className="error-message mt-1">
                          <img
                            src="/images/alert-circle.svg"
                            className="arrow mr-8"
                            alt="Error"
                          />
                          {msg}
                        </div>
                      )}
                    </ErrorMessage>
                  </div>
                </div>

                {/* Activité */}
                <div className="col-md-12 mt-16">
                  <div className="input-wrapper">
                    <label>Activité*</label>
                    <CustomSelect
                      options={filteredActivities.map((activity) => ({
                        value: activity.id,
                        label: activity.name,
                      }))}
                      placeholder="Choisir une activité"
                      onChange={(option) => setFieldValue("activity", option)}
                      selectedValue={values?.activity}
                      isDisabled={!values?.type}
                    />
                    <ErrorMessage name="activity">
                      {(msg) => (
                        <div className="error-message mt-1">
                          <img
                            src="/images/alert-circle.svg"
                            className="arrow mr-8"
                            alt="Error"
                          />
                          {msg}
                        </div>
                      )}
                    </ErrorMessage>
                    {/* {errors?.activity && touched?.activity && (
                      <div className="text-danger">{errors?.activity}</div>
                    )} */}
                  </div>
                </div>
              </div>

              {/* Lieux d'intervention */}
              <div className="col-md-12 mt-24">
                <div className="input-wrapper">
                  <label>Lieux d'intervention*</label>
                  <CustomMultiSelect
                    options={[
                      { label: "À domicile", value: "onsite" },
                      { label: "En ligne", value: "enligne" },
                      { label: "Chez le professionnel", value: "chezpro" },
                    ]}
                    placeholder="Sélectionnez l'option"
                    onChange={(selectedOptions) =>
                      setFieldValue("lieux", selectedOptions)
                    }
                    selectedValues={values?.lieux}
                  />
                  {errors?.lieux && touched?.lieux && (
                    <div className="text-danger">{errors?.lieux}</div>
                  )}
                </div>
                <div className="d-flex mt-8">
                  <div className="col-auto">
                    <img src="/images/annotation-information.svg" alt="info" />
                  </div>
                  <div className="col-md-12">
                    <ul>
                      <li className="grey66 legend">
                        À domicile correspond au domicile du client.
                      </li>
                      <li className="grey66 legend">
                        En ligne correspond au rendez-vous visioconférence
                        organisé automatiquement par Twyny.
                      </li>
                      <li className="grey66 legend">
                        Chez le professionnel correspond à votre
                        cabinet/magasin.
                      </li>
                    </ul>
                  </div>
                </div>

                {values?.lieux?.length > 0 && (
                  <div className="mt-">
                    <How
                      lieu_intervention={values?.lieux}
                      setHow={setFieldValue}
                      todelete={true}
                      onRemoveOption={removeHowOption}
                      from='type'
                    />
                  </div>
                )}
              </div>

              {/* Acceptation des RDV automatique */}
              <div className="col-md-12 mt-24">
                <div className="input-wrapper">
                  <label>
                    Acceptation des RDV automatique*
                    <TooltipTwyny
                      children={
                        <img
                          src="/images/information-circle-contained.svg"
                          alt="information icon"
                          className="ml-8"
                        />
                      }
                      className={""}
                      text="Twyny propose d’accepter automatiquement  ou manuellement les rendez-vous  demandés par vos clients.  Choisissez l’option souhaitée."
                    />
                  </label>
                  <CustomSelect
                    options={[
                      { label: "Oui", value: true },
                      { label: "Non", value: false },
                    ]}
                    placeholder="Sélectionnez l'option"
                    onChange={(option) => setFieldValue("immediat", option)}
                    selectedValue={values?.immediat}
                  />
                  {errors?.immediat && touched?.immediat && (
                    <div className="text-danger">{errors?.immediat}</div>
                  )}
                </div>
              </div>
              {from === "account" ? (
                <button
                  type="submit"
                  onClick={handleSubmit}
                  className="twyny-cta-primary w-100 mt-24"
                >
                  Enregistrer les modifications
                </button>
              ) : (
                ""
              )}
            </Form>
          </>
        )}
      </div>
    </div>
  );
};
